import React from "react";
import { Stack } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { HubBackButton, HubButton } from "../../components";
import { useHubSnackBar } from "../../hooks";
import { StyledInput, StyledTitleStack } from "./styles";

const DocuBuilderBar = ({
  id,
  includeName = true,
  name,
  disabled,
  label = "Document",
  ContextMenu,
  showSubmit = true,
  onDownload,
  extraActions = null,
}) => {
  const { addSnackbarError } = useHubSnackBar();

  const isExisting = !!id;
  const buttonLabel = isExisting ? `Update ${label}` : `Create ${label}`;

  const handleDownload = () => {
    if (onDownload) onDownload();
    else {
      const errorMessage = "Please submit changes before downloading";
      if (!!id || !isDirty) window.print();
      else addSnackbarError({ message: errorMessage });
    }
  };

  const { formState } = useFormContext();
  const isDirty = formState.isDirty;
  const { errors } = formState;

  return (
    <StyledTitleStack>
      <Stack direction="row" gap="10px" alignItems="center">
        <HubBackButton />
        {includeName && (
          <StyledInput
            name="name"
            defaultValue={name}
            placeholder="No Name"
            disabled={disabled}
            required
          />
        )}
      </Stack>
      <Stack direction="row" gap="10px" alignItems="center">
        {extraActions}
        <HubButton
          variant="contained"
          size="xsmall"
          color="neutral"
          icon="Download"
          label="Download"
          iconProps={{
            size: 14,
          }}
          onClick={handleDownload}
          disabled={!id || isDirty}
        />
        {showSubmit && (
          <HubButton
            variant="contained"
            size="xsmall"
            label={buttonLabel}
            type="submit"
          />
        )}
        {ContextMenu}
      </Stack>
    </StyledTitleStack>
  );
};

export default DocuBuilderBar;
